import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" {...props}><text transform="translate(5 32)" fill="currentColor" fontSize="27" fontFamily="MaterialIcons-Regular, Material Icons" data-name="Grupo 283"><tspan x="0" y="0">add</tspan></text></svg>);